import React from "react";
import "./navbar.scss";


function Navbar() {
    return (
        <div className="navbar">
            <img src="./birdLogo.jpeg" alt="logo" />
            <h1>Guess Who?</h1>
        </div>
    )
}

export default Navbar
